import cn from 'classnames'
import { useMemo } from 'react'
import { SelectProps } from 'antd'
import { TYPOGRAPHY_WEIGHT, Typography } from 'components/Typography'
import Default from './select.default'
import { TOption, WithSubtitleProps } from './types'
import './select.withSubtitle.scss'

const WithSubtitle = ({ options, ...props }: WithSubtitleProps) => {
  const formattedOptions = useMemo(
    () =>
      options.map(({ subtitle, ...option }) => ({
        ...option,
        label: (
          <div className="column gap-4">
            <Typography.Body2 weight={TYPOGRAPHY_WEIGHT.SEMI_BOLD}>
              {option.label}
            </Typography.Body2>
            {subtitle && (
              <Typography.Body2 className="grey-text select-option-subtitle">
                {subtitle}
              </Typography.Body2>
            )}
          </div>
        )
      })),
    [options]
  )

  const filterOption = useMemo<SelectProps['filterOption']>(() => {
    if (props.propsSelect?.filterOption !== undefined) {
      return props.propsSelect.filterOption
    }
    return (input, option) => {
      const search = input.toLowerCase()
      const matchedOption = options.find((item) => item.value === option?.value)
      const labelText =
        typeof matchedOption?.label === 'string' ? matchedOption.label : ''

      return (
        labelText.toLowerCase().includes(search) ||
        String(matchedOption?.subtitle ?? '')
          .toLowerCase()
          .includes(search) ||
        String(option?.value ?? '')
          .toLowerCase()
          .includes(search)
      )
    }
  }, [options, props.propsSelect?.filterOption])

  return (
    <Default
      {...props}
      className={cn('select-with-subtitle', props.className)}
      options={formattedOptions as unknown as TOption[]}
      propsSelect={{
        ...props.propsSelect,
        filterOption
      }}
    />
  )
}

export default WithSubtitle
